import { render, staticRenderFns } from "./PoultryHouseManagement.vue?vue&type=template&id=0255122b&scoped=true&"
import script from "./PoultryHouseManagement.vue?vue&type=script&lang=js&"
export * from "./PoultryHouseManagement.vue?vue&type=script&lang=js&"
import style0 from "./PoultryHouseManagement.vue?vue&type=style&index=0&id=0255122b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0255122b",
  null
  
)

export default component.exports